<template>
  <div class="self-button" :class="propClass" :style="propStyle" @click="handleClick">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      width: { //暂时没用到
        type: Number,
        default: 70
      },
      type: {  //1. default 实底白字 2. primary 空白背景，框和字颜色相同
        type: String,
        default: 'default',
        required: true
      },
      color: {
        type: String,
        default: '#45C5DA'
      },
      minWidth: { //如果需要最小宽度，则传
        type: [Number, String],
        default: 70
      },
      noMinWidth: { //是否不需要最小宽度
        type: Boolean,
        default() {
          return false
        }
      },
      size: { //暂时没用到
        type: String,
        default: 'normal'
      },
      plain: { // 设置空白背景，框和字颜色相同时，是否需要自定义颜色，搭配color使用
        type: Boolean,
        default: false
      }
    },
    computed: {
      propClass() {
        switch (this.type) {
          case 'default':
            return 'default-btn';
          case 'primary':
            return 'primary-btn'
        }
      },
      propStyle() {
        let style = {};
        //实底白字
        if (this.type == 'default') {
          style = {
            background: this.color,
            color: '#fff'
          }
          //设置空白背景，框和字颜色相同
        }else if (this.type == 'primary') {
          if (this.plain) {
            style = {
              color: this.color,
              borderWidth: '1px',
              borderColor: this.color,
            }
          }else{
            style = {
              color: '#333',
              borderWidth: '1px',
              borderColor: '#ddd',
            }
          }
        }
        //是否需要设置最小宽度
        if (!this.noMinWidth) {
          style.minWidth = this.minWidth + 'px'
        }
        return style
      }
    },
    created() {

    },
    methods: {
      handleClick() {
        this.$emit('on-click')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'common/sass/theme.scss';
  .self-button{
    display: inline-flex;
    justify-content: center;
    margin-left: 8px;
    padding: 5px 10px;
    line-height: normal;
    font-size: 13px;
    border-radius: 5px;
    box-sizing: border-box;
  }
  .default-btn{
    background: $theme-color;
    color: #fff;
  }
  .primary-btn{
    border: 1px solid #ddd;
  }
</style>